import Vue from 'vue';
import Vuex from 'vuex';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

import fsm from './modules/fsm';
import GameState from './modules/gameState';
import AppState from './modules/appState';
import Auth from './modules/auth';

Vue.use(Vuex);

export const store = new Vuex.Store({
    getters,
    mutations,
    actions,
    modules : {
        fsm,
        GameState,
        AppState,
        Auth,
    },
});
